export const preprocessImage = (videoElement, inputWidth = 640, inputHeight = 640) => {
    const canvas = document.createElement('canvas');
    const [h, w] = [videoElement.videoHeight, videoElement.videoWidth];
    const maxSize = Math.max(w, h);

    canvas.width = maxSize;
    canvas.height = maxSize;
    const ctx = canvas.getContext('2d');

    ctx.fillStyle = '#000000';
    ctx.fillRect(0, 0, maxSize, maxSize);
    ctx.drawImage(videoElement, 0, 0, w, h);

    const tempCanvas = document.createElement('canvas');
    tempCanvas.width = inputWidth;
    tempCanvas.height = inputHeight;
    const tempCtx = tempCanvas.getContext('2d');
    tempCtx.drawImage(canvas, 0, 0, inputWidth, inputHeight);

    const imageData = tempCtx.getImageData(0, 0, inputWidth, inputHeight);
    const float32Data = new Float32Array(3 * inputWidth * inputHeight);

    for (let i = 0; i < imageData.data.length; i += 4) {
        const pixelIndex = i / 4;
        float32Data[pixelIndex] = imageData.data[i] / 255.0;
        float32Data[pixelIndex + inputWidth * inputHeight] = imageData.data[i + 1] / 255.0;
        float32Data[pixelIndex + 2 * inputWidth * inputHeight] = imageData.data[i + 2] / 255.0;
    }

    const xRatio = maxSize / w;
    const yRatio = maxSize / h;

    return { float32Data, xRatio, yRatio };
};

export const processDetections = (output, xRatio, yRatio, threshold = 0.4) => {
    const boxes = [];
    const data = output.data;
    const dims = output.dims;

    const numDetections = dims[2];
    const numClasses = dims[1] - 4;

    for (let i = 0; i < numDetections; i++) {
        const classScores = [];
        for (let j = 0; j < numClasses; j++) {
            classScores.push(data[(4 + j) * numDetections + i]);
        }

        const maxScore = Math.max(...classScores);
        const classId = classScores.indexOf(maxScore);

        if (maxScore > threshold) {
            const x = data[0 * numDetections + i];
            const y = data[1 * numDetections + i];
            const w = data[2 * numDetections + i];
            const h = data[3 * numDetections + i];

            const x1 = (x - w / 2);
            const y1 = (y - h / 2);
            const x2 = (x + w / 2);
            const y2 = (y + h / 2);

            boxes.push({
                y1: y1 * yRatio,
                x1: x1 * xRatio,
                y2: y2 * yRatio,
                x2: x2 * xRatio,
                confidence: maxScore,
                class: classId
            });
        }
    }

    return boxes;
};

export const calculateDistance = (x1, y1, x2, y2) => {
    const xDistance = x2 - x1;
    const yDistance = y2 - y1;
    return Math.sqrt(xDistance * xDistance + yDistance * yDistance);
};

export const isBoxInsideFrame = (box, borderPoints) => {
    const { x1, y1, x2, y2 } = box;
    return (
        x1 > borderPoints.x1 && x1 < borderPoints.x2 &&
        y1 > borderPoints.y1 && y1 < borderPoints.y2 &&
        x2 > borderPoints.x1 && x2 < borderPoints.x2 &&
        y2 > borderPoints.y1 && y2 < borderPoints.y2
    );
};

export const getDetectionFeedback = (pointsDistance, frameBorderDistance, t) => {
    const ratios = {
        done: 0.865,
        keepSteady: 0.85,
        moveCloser: 0.78
    };

    if (frameBorderDistance * ratios.done <= pointsDistance) {
        return {
            message: t('takePhoto.feedback.done'),
            showButton: true,
            autoCapture: true
        };
    } else if (frameBorderDistance * ratios.keepSteady <= pointsDistance) {
        return {
            message: t('takePhoto.feedback.keepSteady'),
            showButton: true,
            autoCapture: false
        };
    } else if (frameBorderDistance * ratios.moveCloser <= pointsDistance) {
        return {
            message: t('takePhoto.feedback.moveCloser'),
            showButton: true,
            autoCapture: false
        };
    } else {
        return {
            message: t('takePhoto.feedback.moveItCloser'),
            showButton: false,
            autoCapture: false
        };
    }
};

